import React, { useState } from 'react';
import ProfileDataManager from './ProfileDataManager.js';


const ProfileDetailsManager = () => {
    return (
        <ProfileDataManager />
    )
}

export default ProfileDetailsManager;
